/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createLand = /* GraphQL */ `mutation CreateLand(
  $input: CreateLandInput!
  $condition: ModelLandConditionInput
) {
  createLand(input: $input, condition: $condition) {
    id
    name
    description
    boundaryJSON {
      name
      key
      url
      __typename
    }
    images {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLandMutationVariables,
  APITypes.CreateLandMutation
>;
export const updateLand = /* GraphQL */ `mutation UpdateLand(
  $input: UpdateLandInput!
  $condition: ModelLandConditionInput
) {
  updateLand(input: $input, condition: $condition) {
    id
    name
    description
    boundaryJSON {
      name
      key
      url
      __typename
    }
    images {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLandMutationVariables,
  APITypes.UpdateLandMutation
>;
export const deleteLand = /* GraphQL */ `mutation DeleteLand(
  $input: DeleteLandInput!
  $condition: ModelLandConditionInput
) {
  deleteLand(input: $input, condition: $condition) {
    id
    name
    description
    boundaryJSON {
      name
      key
      url
      __typename
    }
    images {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLandMutationVariables,
  APITypes.DeleteLandMutation
>;
export const createHouse = /* GraphQL */ `mutation CreateHouse(
  $input: CreateHouseInput!
  $condition: ModelHouseConditionInput
) {
  createHouse(input: $input, condition: $condition) {
    id
    name
    description
    modelJSON {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHouseMutationVariables,
  APITypes.CreateHouseMutation
>;
export const updateHouse = /* GraphQL */ `mutation UpdateHouse(
  $input: UpdateHouseInput!
  $condition: ModelHouseConditionInput
) {
  updateHouse(input: $input, condition: $condition) {
    id
    name
    description
    modelJSON {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHouseMutationVariables,
  APITypes.UpdateHouseMutation
>;
export const deleteHouse = /* GraphQL */ `mutation DeleteHouse(
  $input: DeleteHouseInput!
  $condition: ModelHouseConditionInput
) {
  deleteHouse(input: $input, condition: $condition) {
    id
    name
    description
    modelJSON {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHouseMutationVariables,
  APITypes.DeleteHouseMutation
>;
